import React from 'react';
import { Div, Button, Image, P } from '@kizi/core-components';
import { IProduct, useField } from '@kizi/comparator-core';
import { TabView } from '@kizi/shared-components';
import { Price } from '../../Price';
import { useHandleSubmitClick } from '../../../utils/global';
import { Desktop, Mobile } from '../../../utils/breakpoint';
import { ProductModalContent } from './ProductModalContent';

interface SolarPanelModalOverviewProps {
  data: IProduct;
}

export const SolarPanelModalOverview: React.FC<
  SolarPanelModalOverviewProps
> = ({ data }) => {
  const {
    image,
    provider,
    priceInfo,
    affiliateUrl,
    purchasableProduct,
    type,
    subscriptionName,
  } = data;

  const shouldOpenNewTab = Boolean(affiliateUrl);
  const handleClick = useHandleSubmitClick(shouldOpenNewTab, data, 6);

  const filtersField = useField('overview.filters');
  if (!filtersField || !filtersField.hasOwnProperty('value')) return null;
  const filters = JSON.parse(filtersField.value as string);
  if (!filters) return null;

  const header = (
    <Div
      mb={3}
      display="flex"
      alignItems="stretch"
      justifyContent="space-between"
    >
      <Div display="flex" flexDirection="column">
        <Div maxWidth={232} mt={3} mb={6}>
          <Image
            src={image}
            width="100%"
            height="100%"
            alt={`logo-${provider.name}`}
            display={['none', null, 'block']}
          />
        </Div>

        <P fontSize={'18px'} fontWeight={700} display={['none', null, 'block']}>
          {subscriptionName}
        </P>
      </Div>

      <Div
        display="flex"
        alignItems="center"
        flexDirection={['row', 'row', 'column']}
        css={{ gap: [2, 2, null] }}
        justifyContent="space-between"
      >
        <Price
          value={priceInfo.total}
          label={type === 'solarPanels' ? 'Incl. installatie' : ''}
          variant="priceOsProductModal"
        />
        {purchasableProduct ? (
          <Button
            onClick={() => handleClick()}
            className="buildButton"
            variant="primarySmall"
          >
            Offerte aanvragen
          </Button>
        ) : (
          <Div textAlign="right" maxWidth={150}>
            Geen samenwerking met verzekeraar
          </Div>
        )}
      </Div>
    </Div>
  );

  return (
    <TabView
      display="flex"
      flexDirection="column"
      startIndex={0}
      selectedTabIndex={0}
      tabs={[{ label: '', content: <ProductModalContent data={data} /> }]}
      tabProps={(selected) => ({
        borderBottom: selected ? '3px solid' : 'none',
        fontWeight: 'bold',
        borderColor: '#12DE9A',
        color: 'main.2',
        paddingBottom: 2,
        background: 'red',
      })}
    >
      {(Tabs, Content) => (
        <>
          <Desktop>{header}</Desktop>

          <Div
            overflow="auto"
            display="flex"
            borderBottom="1px solid"
            borderColor="second.1"
          >
            {Tabs}
          </Div>
          <Div py={4} px={3}>
            {Content}
          </Div>

          <Mobile>
            <Div variant="divider" my={4} />
            {header}
          </Mobile>
        </>
      )}
    </TabView>
  );
};
